import { ButtonPrimary } from '@ui/src';
import { CustomerStatus } from '../../../../hoc/common/types';
import { BeneficairyTopContentTypes } from '../types';

import cn from '../styles.module.css';

const BeneficiaryTopContent = ({
  beneficiary,
  errors,
  organizationStatus,
  statusInProgress,
  beneficiaryStatus,
  onSaveStatus,
  updateStatusError,
}: BeneficairyTopContentTypes) => (
  <div className={cn.beneficiaryContentTop}>
    <div className={cn.beneficiaryName}>
      {beneficiary.name}
      {errors?.name && (
        <div className={cn.nameError}>{errors?.name?.message}</div>
      )}
    </div>
    <div className={cn.beneficiarySaveWrapper}>
      {organizationStatus !== CustomerStatus.CLOSED && (
        <div className={cn.saveStatusButtonWrapper}>
          <ButtonPrimary
            text={statusInProgress ? 'Loading...' : 'Save Changes'}
            className={cn.saveStatusButton}
            disabled={
              beneficiary.status === beneficiaryStatus || statusInProgress
            }
            onClick={onSaveStatus}
            bold
          />
        </div>
      )}

      {updateStatusError && (
        <div className={cn.updateStatusError}>{updateStatusError}</div>
      )}
    </div>
  </div>
);

export default BeneficiaryTopContent;
